import { FunctionalMarginValidation } from "@inter-ikea-core/core";
export const validations = {
    FunctionalMarginValidation: ({ core }) => new FunctionalMarginValidation(false, core.services.entityManager),
};
